function SaoTomeAndPrince({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_2015)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#FFDA44"/>
  <path d="M9.73908 10.4348H31.0047C28.7441 4.342 22.8793 0 15.9999 0C11.5816 0 7.58202 1.79119 4.68677 4.68681L9.73908 10.4348Z" fill="#6DA544"/>
  <path d="M9.73908 21.5654H31.0047C28.7441 27.6582 22.8793 32.0002 15.9999 32.0002C11.5816 32.0002 7.58202 30.2091 4.68677 27.3134L9.73908 21.5654Z" fill="#6DA544"/>
  <path d="M4.68628 4.68652C-1.56209 10.9349 -1.56209 21.0656 4.68628 27.314C7.26834 24.732 9.75165 22.2486 16 16.0003L4.68628 4.68652Z" fill="#D80027"/>
  <path d="M20.3172 13.2178L21.0079 15.3435H23.243L21.4347 16.6573L22.1254 18.783L20.3172 17.4692L18.5089 18.783L19.1995 16.6573L17.3914 15.3435H19.6265L20.3172 13.2178Z" fill="black"/>
  <path d="M27.2737 13.2178L27.9643 15.3435H30.1994L28.3912 16.6573L29.0818 18.783L27.2737 17.4692L25.4653 18.783L26.156 16.6573L24.3478 15.3435H26.5829L27.2737 13.2178Z" fill="black"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default SaoTomeAndPrince;
